import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { Facet, PageName } from '@app/constants';

//import { DataService } from '@app/data';

@Component({
  selector: 'app-facet',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './facet.component.html',
  styleUrls: ['./facet.component.less']
})
export class FacetComponent {

  @Input() chip?: any;
  @Input() displayCount?: boolean = true;
  //@Input() pageName?: PageName;

  /*constructor(
    private data: DataService
  ) { }*/

  

}
